import "./POIWidgetPreview.scss";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import copy from "copy-to-clipboard";

export default {
  name: "POIWidgetPreview",
  props: ["previewItem", "showDialog"],
  methods: {
    copyToClipboard(text) {
      copy(text);
      this.$store.dispatch("createSuccess", "Erfolgreich kopiert");
    }
  },
  computed: {
    cShowDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        if (!val) this.$emit("close");
      }
    },
    iframeURL() {
      return `${env.poi_widget_api_url}iframed.html?api_key=${this.previewItem?.apiKey}&color=${this.previewItem?.output?.colors?.baseColor}`;
    },
    widgetCode() {
      return `<!-- EO POI Widget Schnipsel Anfang -->
<div id="eo-poi-widget"></div>
<script>
  var _eopoi = {}; // reset
  _eopoi.apiKey = '${this.previewItem.apiKey}';
  _eopoi.insertId = 'eo-poi-widget';
  var head = document.getElementsByTagName('head')[0];
  var script = document.createElement('script');
  script.src = 'https://eo-poi-widget.api.eo-heimat.de/v1/eopoi.bundle.js';
  script.async = true;
  head.appendChild(script);
  var script2 = document.createElement('script');
  script2.src = "https://eo-poi-widget.api.eo-heimat.de/v1/1.eopoi.bundle.js";
  script2.async = true;
  head.appendChild(script2);
</script>
<noscript>Bitte Javascript anschalten, um die POIs im Umkreis zu sehen.</noscript>
<!-- EO POI Widget Schnipsel Ende -->`;
    },
    iFrameCode() {
      return `<iframe
  style="width: 100%; height: 1200px"
  src="${this.iframeURL}"
></iframe>`;
    }
  }
};
